import { LanguagesState } from './types'

export const DEFAULT_LANG = 'default'

export const initialState: LanguagesState = {
  languages: [],
  ready: false,
}
